import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  Button,
  Toolbar,
  Typography,
  MenuItem,
  IconButton,
  Popover,
  Grid,
  Icon
} from '@material-ui/core';
import { Field, reduxForm, getFormValues } from 'redux-form';
import cx from 'classnames';
import FormSelect from '../../../components/Form/FormSelect';
import FormTextField from '../../../components/Form/FormTextField';
import { getHomeFilters, listVehicles } from '../../../actions';
import { PageWrapper, Switcher } from '../../../components';
import { SELLER_PURCHASE_OPTIONS, VEHICLES_PER_PAGE } from '../../../constants';
import { numberFormatString } from '../../../utils';
import { setFilters } from '../../../services/auctions/liveAuctionsSlice';

const SwitcherWithMargin = styled(Switcher)`
  margin-left: 25px;
`;

const SearchByTypography = styled(Typography)`
  && {
    margin: auto 10px;
    @media only screen and (max-width: 1100px) {
      font-size: 14px;
    }
    @media only screen and (max-width: 1024px) {
      display: none;
    }
  }
`;

const StyledGuaranteedTypography = styled(Typography)`
  && {
    @media only screen and (max-width: 1100px) {
      font-size: 14px;
    }
  }
`;

const StyledSelect = styled(FormSelect)`
  && {
    width: 100px;
    margin-right: 8px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    font-weight: 400;
    padding: 2px 6px;
    border-radius: 4px;
    height: 36px;
    div {
      font-size: 14px;
      color: #757575;
    }
  }
`;

const StyledPopoverGridItem = styled(Grid)`
  && {
    display: flex;
    align-items: flex-end;
    padding: 4px 0;
    flex-basis: 56px;
  }
`;

const StyledBluebookButton = styled(Button)`
  && {
    min-width: 120px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    height: 36px;
    padding: 2px 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    * {
      text-align: left;
      justify-content: flex-start;
    }
    :hover {
      background: none;
    }
    @media only screen and (max-width: 1100px) {
      font-size: 12px;
    }
    @media only screen and (max-width: 1024px) {
      font-size: 14px;
    }
  }
`;

const StyledClearTextButton = styled.span`
  && {
    cursor: pointer;
    display: block;
    text-decoration: underline;
  }
`;

const StyledClearIconButton = styled(IconButton)`
  && {
    display: none;
  }
`;

const StyledFiltersButton = styled.div`
  && {
    display: none;
    align-items: center;
    @media only screen and (max-width: 1024px) {
      display: flex;
    }
    &.expanded {
      margin-top: 12px;
    }
  }
`;

const StyledControlButton = styled(Button)`
  && {
    min-height: 0;
    width: 24px;
    height: 24px;
    font-size: 16px;
    box-shadow: none;
    margin: 0 8px;
  }
`;

const StyledIcon = styled(Icon)`
  && {
    font-size: 16px;
  }
`;

const StyledBluebookSubmitButtonHolder = styled(StyledPopoverGridItem)`
  justify-content: flex-end;
`;

const StyledBluebookSubmitButton = styled(Button)`
  && {
    margin: 0 8px;
  }
`;

const StyledCountSpan = styled.span`
  disply: inline-block;
  margin-left: 10px;
  color: #aeaeae;
`;

const formName = 'filtersForm';

class HomeFilters extends Component {
  constructor() {
    super();
    this.state = {
      expanded: window.innerWidth > 1024,
      // expanded: true,
      isGuaranteed: false,
      anchorEl: null,
      minRange: null,
      maxRange: null
    };
  }

  componentDidMount() {
    const { fetchHomeFilters } = this.props;
    fetchHomeFilters({ params: { location_id: 1 } });
  }

  componentWillReceiveProps(nextProps) {
    const { updateFilters, values, currentLocation, perPage } = this.props;
    if (JSON.stringify(values) !== JSON.stringify(nextProps.values)) {
      const filterObj = {};
      Object.keys(nextProps.values).map(item => {
        // if (nextProps.values[item] !== '0' && !['minRange', 'maxRange'].includes(item)) {
        if (nextProps.values[item] !== '0') {
          filterObj[item] = nextProps.values[item];
        }
        return item;
      });
      updateFilters(filterObj);
      // fetchVehicles({
      //   params: {
      //     ...filterObj,
      //     location_id: currentLocation.id,
      //     offset: 0,
      //     limit: perPage
      //   }
      // });
    }
  }

  toggleSwitch = () => {
    const { isGuaranteed } = this.state;
    this.setState({ isGuaranteed: !isGuaranteed });
  };

  updateStateValue = (key, value) => {
    this.setState({ [key]: value });
  };

  handleResetFilters = () => {
    const { reset } = this.props;
    this.updateStateValue('minRange', null);
    this.updateStateValue('maxRange', null);
    reset();
  };

  handleOpenBluebookPopover = e => {
    this.setState({
      anchorEl: e.currentTarget
    });
  };

  handleCloseBluebookPopover = () => {
    this.setState({
      anchorEl: null
    });
  };

  handleToggleFilters = () => {
    const { expanded } = this.state;
    this.setState({
      expanded: !expanded
    });
  };

  render() {
    const { expanded, anchorEl, minRange, maxRange } = this.state;
    const { filters, values, change } = this.props;
    const filtersModels =
      values && values.make
        ? (filters.models || [])
            .filter(item => item.make === values.make)
            .map((item, i) => (
              <MenuItem value={item.model} key={i}>
                {item.model}
              </MenuItem>
            ))
        : [];

    const formEmpty =
      !values ||
      (values.make === '0' &&
        values.model === '0' &&
        values.seller === '0' &&
        values.purchase === '0' &&
        !values.minRange &&
        !values.maxRange &&
        values.region === '0' &&
        !Object.prototype.hasOwnProperty.call(values, 'guaranteed'));

    let blueBookRangeButtonText = 'Blue Book Range';
    if (values.minRange || values.maxRange) {
      const formattedMinRange =
        values.minRange && numberFormatString(values.minRange);
      const formattedMaxRange =
        values.maxRange && numberFormatString(values.maxRange);
      if (values.minRange && values.maxRange) {
        blueBookRangeButtonText = `${formattedMinRange} - ${formattedMaxRange}`;
      } else if (values.minRange) {
        blueBookRangeButtonText = `More than ${formattedMinRange}`;
      } else {
        blueBookRangeButtonText = `Less than ${formattedMaxRange}`;
      }
    }

    return (
      <div className="headerFiltersPanel">
        <PageWrapper>
          <Toolbar className="headerFiltersToolbar">
            <StyledFiltersButton
              onClick={this.handleToggleFilters}
              className={cx('', { expanded })}
            >
              <span>Filter by</span>
              <i className="material-icons">
                {expanded ? 'expand_less' : 'expand_more'}
              </i>
            </StyledFiltersButton>
            <div
              className={cx('collapsible-container', {
                'show-filters': expanded
              })}
              style={{ overflow: 'visible' }}
            >
              <div className="filters">
                <SearchByTypography>Search By</SearchByTypography>
                <Field
                  name="make"
                  id="make"
                  component={StyledSelect}
                  InputProps={{
                    disableUnderline: true
                  }}
                  InputLabelProps={
                    {
                      // shrink: false
                    }
                  }
                >
                  <MenuItem value="0">Make</MenuItem>
                  {(filters.makes || []).map((item, i) => (
                    <MenuItem value={item.make} key={i}>
                      {item.make}
                      {(formEmpty ||
                        (values.make !== '0' && values.seller === '0')) && (
                        <StyledCountSpan>{`(${item.count})`}</StyledCountSpan>
                      )}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="model"
                  id="model"
                  component={StyledSelect}
                  disabled={!values.make}
                  InputLabelProps={{
                    shrink: false
                  }}
                  InputProps={{
                    disableUnderline: true
                  }}
                >
                  <MenuItem value="0">Model</MenuItem>
                  {filtersModels}
                </Field>
                <StyledBluebookButton
                  variant="outlined"
                  onClick={this.handleOpenBluebookPopover}
                  title={blueBookRangeButtonText}
                >
                  {blueBookRangeButtonText}
                </StyledBluebookButton>
                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={this.handleCloseBluebookPopover}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                  }}
                >
                  <Grid container wrap="wrap" direction="column">
                    <StyledPopoverGridItem item xs={12}>
                      <StyledControlButton
                        variant="fab"
                        color="secondary"
                        onClick={() => {
                          const newValue = +minRange - 100;
                          if (newValue >= 0) {
                            this.updateStateValue('minRange', newValue);
                          }
                        }}
                        disabled={+minRange - 100 < 0 || +minRange < 0}
                      >
                        <StyledIcon>remove</StyledIcon>
                      </StyledControlButton>
                      <FormTextField
                        name="minRange"
                        id="minRange"
                        placeholder="Min"
                        value={minRange}
                        type="number"
                        meta={{
                          touched: false,
                          invalid: false
                        }}
                        onChange={e =>
                          this.updateStateValue('minRange', e.target.value)
                        }
                      />
                      <StyledControlButton
                        variant="fab"
                        color="secondary"
                        onClick={() => {
                          this.updateStateValue('minRange', +minRange + 100);
                        }}
                      >
                        <StyledIcon>add</StyledIcon>
                      </StyledControlButton>
                    </StyledPopoverGridItem>
                    <StyledPopoverGridItem item xs={12}>
                      <StyledControlButton
                        variant="fab"
                        color="secondary"
                        onClick={() => {
                          const newValue = +maxRange - 100;
                          if (newValue >= 0) {
                            this.updateStateValue('maxRange', newValue);
                          }
                        }}
                        disabled={+maxRange - 100 < 0 || +maxRange < 0}
                      >
                        <StyledIcon>remove</StyledIcon>
                      </StyledControlButton>
                      <FormTextField
                        name="maxRange"
                        id="maxRange"
                        placeholder="Max"
                        value={maxRange}
                        type="number"
                        meta={{
                          touched: false,
                          invalid: false
                        }}
                        onChange={e =>
                          this.updateStateValue('maxRange', e.target.value)
                        }
                      />
                      <StyledControlButton
                        variant="fab"
                        color="secondary"
                        onClick={() => {
                          this.updateStateValue('maxRange', +maxRange + 100);
                        }}
                      >
                        <StyledIcon>add</StyledIcon>
                      </StyledControlButton>
                    </StyledPopoverGridItem>
                    <StyledBluebookSubmitButtonHolder item container xs={12}>
                      <StyledBluebookSubmitButton
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          if (minRange > 0) {
                            change('minRange', minRange);
                          } else {
                            change('minRange', null);
                          }
                          if (maxRange > 0) {
                            change('maxRange', maxRange);
                          } else {
                            change('maxRange', null);
                          }
                        }}
                        disabled={
                          (+minRange > 0 &&
                            +maxRange > 0 &&
                            +maxRange < +minRange) ||
                          +minRange % 100 !== 0 ||
                          +maxRange % 100 !== 0 ||
                          +minRange < 0 ||
                          +maxRange < 0
                        }
                      >
                        Apply
                      </StyledBluebookSubmitButton>
                    </StyledBluebookSubmitButtonHolder>
                  </Grid>
                </Popover>
                <Field
                  name="seller"
                  id="seller"
                  component={StyledSelect}
                  InputProps={{
                    disableUnderline: true
                  }}
                  InputLabelProps={{
                    shrink: false
                  }}
                >
                  <MenuItem value="0">Sellers</MenuItem>
                  {(filters.sellers || []).map((item, i) => (
                    <MenuItem value={item.id} key={i}>
                      {item.name}
                      {(formEmpty ||
                        (values.make === '0' && values.seller !== '0')) && (
                        <StyledCountSpan>{`(${item.count})`}</StyledCountSpan>
                      )}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="region"
                  id="region"
                  component={StyledSelect}
                  InputProps={{
                    disableUnderline: true
                  }}
                  InputLabelProps={{
                    shrink: false
                  }}
                >
                  <MenuItem value="0">Regions</MenuItem>
                  {(filters.regions || []).map((item, i) => (
                    <MenuItem value={item.id} key={i}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="purchase"
                  id="purchase"
                  type="text"
                  component={StyledSelect}
                  InputProps={{
                    disableUnderline: true
                  }}
                  InputLabelProps={{
                    shrink: false
                  }}
                  style={{ width: 140 }}
                >
                  <MenuItem value="0">Purchase Method</MenuItem>
                  {Object.keys(SELLER_PURCHASE_OPTIONS).map((item, i) => (
                    <MenuItem value={item} key={i}>
                      {SELLER_PURCHASE_OPTIONS[item]}
                    </MenuItem>
                  ))}
                </Field>
                {!formEmpty && (
                  <>
                    <StyledClearTextButton onClick={this.handleResetFilters}>
                      Clear search
                    </StyledClearTextButton>
                    <StyledClearIconButton onClick={this.handleResetFilters}>
                      <i className="material-icons">cancel</i>
                    </StyledClearIconButton>
                  </>
                )}
              </div>
            </div>
            <div
              className={cx('garanteed-select', {
                'show-filters': expanded
              })}
            >
              <StyledGuaranteedTypography>
                Only Guaranteed Vehicle
              </StyledGuaranteedTypography>
              <Field
                name="guaranteed"
                component={SwitcherWithMargin}
                type="checkbox"
              />
            </div>
          </Toolbar>
        </PageWrapper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.vehicles.homeFilters,
  values: getFormValues(formName)(state) || {},
  // currentVin: formValueSelector('vinForm')(state, 'vin'),
  currentLocation: state.locations.currentLocation,
  perPage: +VEHICLES_PER_PAGE
});

const mapDispatchToProps = dispatch => ({
  fetchHomeFilters: data => dispatch(getHomeFilters(data).request),
  fetchVehicles: params => dispatch(listVehicles(params).request),
  updateFilters: params => dispatch(setFilters(params)),
});

export default reduxForm({
  form: formName,
  initialValues: {
    make: '0',
    model: '0',
    seller: '0',
    purchase: '0',
    region: '0'
  },
  destroyOnUnmount: false
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HomeFilters)
);
